import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SVG404 } from './shapes';
import { persimmon } from './colors';

var FourOhFour =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FourOhFour, _PureComponent);

  function FourOhFour() {
    _classCallCheck(this, FourOhFour);

    return _possibleConstructorReturn(this, _getPrototypeOf(FourOhFour).apply(this, arguments));
  }

  _createClass(FourOhFour, [{
    key: "render",
    value: function render() {
      var message = this.props.message;
      return React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, React.createElement("div", {
        style: {
          maxWidth: '550px',
          margin: '0 auto'
        }
      }, React.createElement(SVG404, null)), React.createElement("div", {
        style: {
          maxWidth: '500px',
          margin: '0 auto'
        }
      }, React.createElement("h1", {
        style: {
          color: persimmon.base
        }
      }, "404 Page Not Found"), message));
    }
  }]);

  return FourOhFour;
}(PureComponent);

export { FourOhFour as default };
FourOhFour.propTypes = {
  message: PropTypes.node
};
FourOhFour.defaultProps = {
  message: 'Oops! Something has gone wrong and the page you were looking for could not be displayed. Try the homepage.'
};